<div class="modal-content">
  <div
    class="modal-header border-bottom px-4 py-3 d-flex align-items-center justify-content-between"
  >
    <div>
      <h4 class="modal-title fw-bold text-dark mb-0">
        {{ 'COMMON.NOTIFICATION' | translate }}
      </h4>
      <div class="text-secondary small mt-1">
        {{
          'NOTIFICATION_DIALOG.UNREAD_COUNT'
            | translate: { count: notificationService.unreadCount() }
        }}
      </div>
    </div>

    <div class="d-flex align-items-center gap-2">
      <button
        type="button"
        class="btn btn-link text-decoration-none small fw-semibold px-2"
        [disabled]="notificationService.unreadCount() === 0"
        (click)="markAllAsRead()"
      >
        <svg lucideCheckCheck [size]="16" class="me-1"></svg>
        {{ 'NOTIFICATION_DIALOG.MARK_ALL_AS_READ' | translate }}
      </button>
      <button
        type="button"
        class="btn-close shadow-none"
        (click)="activeModal.dismiss()"
        [attr.aria-label]="'COMMON.CLOSE' | translate"
      ></button>
    </div>
  </div>

  <div class="modal-body px-0 py-0 notification-body">
    @if (isBusy() && items().length === 0) {
      <div
        class="loading-state minh-385 px-4 py-5 text-center text-secondary small d-flex flex-column align-items-center justify-content-center gap-3"
      >
        <div
          class="spinner-border text-primary width-30 height-30"
          role="status"
          aria-hidden="true"
        ></div>
        <div>{{ 'NOTIFICATION_DIALOG.LOADING' | translate }}</div>
      </div>
    } @else if (items().length === 0) {
      <div class="empty-state minh-385 px-4 py-5 text-center">
        <div
          class="width-55 height-55 bg-secondary-subtle text-secondary mx-auto mb-3 rounded-circle d-flex align-items-center justify-content-center"
        >
          <svg lucideBell [size]="24"></svg>
        </div>
        <div class="fw-semibold text-dark">
          {{ 'NOTIFICATION_DIALOG.EMPTY_TITLE' | translate }}
        </div>
        <div class="text-secondary small mt-1">
          {{ 'NOTIFICATION_DIALOG.EMPTY_DESCRIPTION' | translate }}
        </div>
      </div>
    } @else {
      <div class="notification-list" (scroll)="onScroll($event)">
        @for (item of items(); track item.id) {
          <button
            type="button"
            class="notification-item transition-all w-100 text-start border-0 border-bottom bg-transparent px-4 py-3"
            [class.is-unread]="!item.is_read"
            (click)="markAsRead(item)"
          >
            <div class="d-flex align-items-start gap-3">
              <div
                class="width-40 height-40 rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                [ngClass]="iconWrapperClass(item.type)"
              >
                @switch (item.type) {
                  @case ('alert') {
                    <svg lucideCircleAlert [size]="18"></svg>
                  }
                  @case ('success') {
                    <svg lucideCircleCheckBig [size]="18"></svg>
                  }
                  @case ('security') {
                    <svg lucideShield [size]="18"></svg>
                  }
                  @default {
                    <svg lucideBell [size]="18"></svg>
                  }
                }
              </div>

              <div class="flex-grow-1 minw-0">
                <div
                  class="d-flex align-items-center justify-content-between gap-2"
                >
                  <div class="notification-title text-dark fw-semibold">
                    {{ item.title }}
                  </div>
                  @if (!item.is_read) {
                    <span
                      class="unread-dot width-10 height-10 rounded-circle bg-danger flex-shrink-0"
                    ></span>
                  }
                </div>
                <div class="notification-message text-secondary small mt-1">
                  {{ item.message }}
                </div>
                <div class="notification-time text-muted small mt-2">
                  {{
                    getRelativeTime(item.created_date).key
                      | translate: getRelativeTime(item.created_date).params
                  }}
                </div>
              </div>
            </div>
          </button>
        }
        @if (notificationService.isLoadingMore()) {
          <div
            class="d-flex justify-content-center align-items-center py-3 border-top bg-light-subtle"
          >
            <div
              class="spinner-border text-primary spinner-border-sm"
              role="status"
            >
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        }
      </div>
    }
  </div>

  <div class="modal-footer border-top p-3 d-flex justify-content-end">
    <button
      type="button"
      class="btn btn-outline-secondary px-4 py-2 fw-medium rounded"
      (click)="activeModal.close()"
    >
      {{ 'COMMON.CLOSE' | translate }}
    </button>
  </div>
</div>
